import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Routes, Route, useNavigate, Navigate, Outlet } from "react-router-dom";
import LoginTab from "./View/Component/LoginorSignup/logintab";
import Heartest from "./View/Component/HearTest/Heartest";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./View/Component/Dashboard/Dashboard";
import Step2 from "./View/Component/HearTest/Step2";
import Step3 from "./View/Component/HearTest/step3";
import Step4 from "./View/Component/HearTest/step4";
import Step5 from "./View/Component/HearTest/step5";
import Step6 from "./View/Component/HearTest/step6";
import Step7 from "./View/Component/HearTest/step7";
import Step8 from "./View/Component/HearTest/step8";
import Step9 from "./View/Component/HearTest/step9";
import Measuretest from "./View/Component/HearTest/Measuretest";
import VoiceTest from "./View/Component/HearTest/Voice2khzright";
import VoiceTestRight from "./View/Component/HearTest/Voice4khzright";
import VoiceTestLeftHigh from "./View/Component/HearTest/Voice6khzleft";
import VoiceTestLeft from "./View/Component/HearTest/Voice2khzleft";
import Warning from "./View/Component/HearTest/Warning";
import Result from "./View/Component/HearTest/HearResult/Result";
import Home from "./View/Component/Home/Home";
import Calendar from "./View/Component/Dashboard/Calendar/CalendarPage";
import "./App.css";
import "./View/Component/Global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Login from "./View/Component/Login/Login";
import Signup from "./View/Component/SignUp/signup";
import ForgotPass from "./View/Component/ForgotPassword/ForgotPass";
import HearingServices from "./View/Component/Services/HearingServices";
import HearingImplants from "./View/Component/Services/HearingImplants";
import EarMeasurements from "./View/Component/Services/EarMeasurements";
import PhonakHearing from "./View/Component/Products/PhonakHearing";
import HearingAidRepairs from "./View/Component/Services/HearingAidRepairs";
import SigniaHearingAids from "./View/Component/Products/SigniaHearingAids";
import Contact from "./View/Component/Contact/contact";
import ResoundHearingAid from "./View/Component/Products/ResoundHearingAid";
import StarkeyHearingAids from "./View/Component/Products/StarkeyHearingAids";
import Page404 from "./View/Component/Page404/Page404";
import PrivateRoute from "./View/Component/ProtectedRoute/ProtectedRoute";
import PublicRoute from "./View/Component/PublicRoute/PublicRoute";
import About from "./View/Component/About/About";
import FAQ from "./View/Component/FAq/FAQ";
import Testimonials from "./View/Component/Testimonials/Testimonials";
import MyHistory from "./View/Component/Dashboard/MyHistory/History";
import Blogs from "./View/Component/Blogs/Blogs";
import BlogsView from "./View/Component/Blogs/BlogsView/BlogsView";
import INVOICE from "./View/Component/Dashboard/INVOICE/INVOICE";
import VoiceTest500 from "./View/Component/HearTest/Voice500khzright";
import VoiceTestright1khz from "./View/Component/HearTest/Voice1khzleft";
import Voiceleft500khz from "./View/Component/HearTest/Voice500hzleft";
import Voice2000khz from "./View/Component/HearTest/Voice2000khzleft";
import Profile from "./View/Component/Dashboard/Profile/Profile";
import MyPoints from "./View/Component/Dashboard/MyPoints/MyPoints";
import WOW from "wowjs";
function App() {
  // const clearLocalStorage = () => {
  //   localStorage.removeItem("access_token");
  //   localStorage.removeItem("UserName");
  //   localStorage.removeItem("lastName");
  //   localStorage.removeItem("step2");
  //   localStorage.removeItem("step3");
  //   localStorage.removeItem("step4");
  //   localStorage.removeItem("step5");
  //   localStorage.removeItem("step6");
  //   localStorage.removeItem("step7");
  //   localStorage.removeItem("step8");
  //   localStorage.removeItem("step9");
  //   localStorage.removeItem("Rightear2KHz");
  //   localStorage.removeItem("Rightear4KHz");
  //   localStorage.removeItem("Leftear1KHz");
  //   localStorage.removeItem("Leftear6KHz");
  //   localStorage.removeItem("Measuretest");
  //   localStorage.removeItem("Roleid");
  //   localStorage.removeItem("id");
  //   localStorage.removeItem("result_test_id");
  //   localStorage.removeItem("Rightear500Hz");
  //   localStorage.removeItem("rightear1KHz");
  //   localStorage.removeItem("Leftear500Hz");
  //   localStorage.removeItem("Leftear2000KHz");
  //   localStorage.removeItem("UserName");
  //   localStorage.removeItem("LastName");
  // };

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     clearLocalStorage();
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  // useEffect(() => {
  //   const wow = new WOW.WOW();
  //   wow.init();
  // }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/*" element={<Page404 />} />

        <Route path="Signup" element={<PublicRoute />}>
          <Route path="/Signup" element={<Signup />} />
        </Route>

        <Route path="ForgotPass" element={<PublicRoute />}>
          <Route path="/ForgotPass" element={<ForgotPass />} />
        </Route>

        <Route path="Login" element={<PublicRoute />}>
          <Route path="/Login" element={<Login />} />
        </Route>

        {/* <Route path="/" element={<PublicRoute />}> */}
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/Testimonials" element={<Testimonials />} />
        <Route
          path="/Services/Hearing-Services"
          element={<HearingServices />}
        />
        <Route
          path="/Services/Hearing-Implants"
          element={<HearingImplants />}
        />

        <Route
          path="/Services/Ear-Measurements"
          element={<EarMeasurements />}
        />

        <Route
          path="/Services/hearing-aid-repairs-and-adjustments"
          element={<HearingAidRepairs />}
        />
        <Route path="/Products/Phonak-Hearing" element={<PhonakHearing />} />
        <Route
          path="/Products/signia-hearing-aids-the-hearing-centre-singapore"
          element={<SigniaHearingAids />}
        />
        <Route path="/contact" element={<Contact />} />

        <Route
          path="/Products/resound-hearing-aid"
          element={<ResoundHearingAid />}
        />

        <Route
          path="/Products/starkey-hearing-aids"
          element={<StarkeyHearingAids />}
        />
        <Route path="/Blogs" element={<Blogs />} />
        <Route path="/Blogs/BlogsView" element={<BlogsView />} />
        {/* </Route> */}

        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Outlet />}>
            <Route path="/" element={<Navigate replace to="Calendar" />} />
            <Route path="*" element={<Page404 home={true} />} />
            <Route path="Calendar" element={<Calendar />} />
            <Route path="MyHistory" element={<MyHistory />} />
            <Route path="Profile" element={<Profile />} />
            <Route path="MyPoints" element={<MyPoints />} />
            <Route path="Invoice" element={<INVOICE />} />

            <Route path="Heartest" element={<Heartest />} />
            <Route path="hearingtest/age-range" element={<Step2 />} />
            <Route path="hearingtest/intro" element={<Step3 />} />
            <Route
              path="hearingtest/listening-situations/1"
              element={<Step4 />}
            />
            <Route
              path="hearingtest/listening-situations/2"
              element={<Step5 />}
            />
            <Route
              path="hearingtest/listening-situations/3"
              element={<Step6 />}
            />
            <Route
              path="hearingtest/listening-situations/4"
              element={<Step7 />}
            />
            <Route path="hearingtest/headphones" element={<Step8 />} />
            <Route path="hearingtest/setup-instructions" element={<Step9 />} />
            <Route
              path="hearingtest/quiet-environment"
              element={<Measuretest />}
            />
            <Route
              path="hearingtest/measurement/right-2000"
              element={<VoiceTest />}
            />
            <Route
              path="hearingtest/measurement/right-4000"
              element={<VoiceTestRight />}
            />

            <Route
              path="hearingtest/measurement/left-1000"
              element={<VoiceTestLeft />}
            />
            <Route
              path="hearingtest/measurement/left-4000"
              element={<VoiceTestLeftHigh />}
            />
            <Route
              path="hearingtest/measurement/right-500"
              element={<VoiceTest500 />}
            />
            <Route
              path="hearingtest/measurement/Warning"
              element={<Warning />}
            />

            <Route
              path="hearingtest/measurement/right-1000"
              element={<VoiceTestright1khz />}
            />
            <Route
              path="hearingtest/measurement/left-2000"
              element={<Voice2000khz />}
            />
            <Route
              path="hearingtest/measurement/left-500"
              element={<Voiceleft500khz />}
            />
            <Route path="hearingtest/result-full" element={<Result />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
